
import { useNavigate } from 'react-router-dom';

export default function Hero() {
  const navigate = useNavigate();

  return (
    <div className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Simple Gradient Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#8b7355] via-[#6b5d4f] to-[#4a3f35]"></div>
      
      {/* Dark Overlay for better text contrast */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        <h1 className="text-6xl md:text-7xl font-light text-white mb-6 tracking-wide" style={{ fontFamily: 'Georgia, serif' }}>
          게임기획자 해든의<br />아이디어 낙서 블로그
        </h1>
        
        <p className="text-xl md:text-2xl text-white/90 mb-12 font-light leading-relaxed">
          하이브리드 캐주얼 게임 히트작을 분석하고, 새로운 게임을 상상합니다
        </p>

        {/* Quick Links */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-16">
          <button
            onClick={() => navigate('/board/idea-archive')}
            className="group px-8 py-4 bg-white/95 hover:bg-white text-[#5a4a3a] rounded-lg transition-all duration-300 flex items-center gap-3 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
          >
            <i className="ri-gamepad-fill text-2xl"></i>
            <div className="text-left">
              <div className="text-sm font-light text-[#8b7d6f]">기획 노트</div>
              <div className="text-base font-normal">코어루프 기획 아카이빙</div>
            </div>
            <i className="ri-arrow-right-line text-lg group-hover:translate-x-1 transition-transform"></i>
          </button>

          <button
            onClick={() => navigate('/board/core-loop')}
            className="group px-8 py-4 bg-white/95 hover:bg-white text-[#8b4513] rounded-lg transition-all duration-300 flex items-center gap-3 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
          >
            <i className="ri-fire-fill text-2xl"></i>
            <div className="text-left">
              <div className="text-sm font-light text-[#8b7d6f]">글로벌 관찰</div>
              <div className="text-base font-normal">히트 코어루프 분석</div>
            </div>
            <i className="ri-arrow-right-line text-lg group-hover:translate-x-1 transition-transform"></i>
          </button>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-3xl mx-auto">
          <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg p-4">
            <div className="text-3xl font-light text-white mb-1">21+</div>
            <div className="text-sm text-white/80">분석 게시글</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg p-4">
            <div className="text-3xl font-light text-white mb-1">6+</div>
            <div className="text-sm text-white/80">프로토타입</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg p-4">
            <div className="text-3xl font-light text-white mb-1">4</div>
            <div className="text-sm text-white/80">연구 카테고리</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg p-4">
            <div className="text-3xl font-light text-white mb-1">매주</div>
            <div className="text-sm text-white/80">새로운 인사이트</div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-white/60"></i>
      </div>
    </div>
  );
}